import {serializr, indirectReference, classConstructorParam, indirectObject, funct } from '@mecatran/serializr-extensions';
import * as model from "./model.mjs";

export {model};

// =========
// variables
// --------- 
var {   createModelSchema, 
    createSimpleSchema, 
    primitive, 
    reference, 
    date, raw, list, object, 
    optional, alias,
    identifier, map, mapAsArray , 
    custom, 
    getDefaultModelSchema, 
    setDefaultModelSchema,
    serialize, 
    deserialize } = serializr;


  
function factory(clazz ){
    return function(){
        return new clazz();
    }
}

var schemaGeojson = {
    factory : factory(model.Geojson),
    props : {
        type : true, 
        features : list(object(model.Feature)) // TMP this model depend on the type model, here we are assuming that the type is a feature
    }
}

var schemaFeature = {
    factory : factory(model.Feature),
    props :{
        type : true,
        geometry : object(model.Geometry),
        properties : object(model.Properties)
    }
}

var schemaGeometry = {
    factory : factory(model.Geometry),
    props : {
        type : true,
        coordinates : raw()
    }
}


var schemaProperties = {
    factory : factory(model.Properties),
    props : {
        poiName : alias('NOM_POI',true),
        commune : alias('COMMUNE',true),
		label : true,
		city : true
    }
}


/*
setDefaultModelSchema( model.Geojson, schemaGeojson );
setDefaultModelSchema( model.Feature, schemaFeature );
setDefaultModelSchema( model.Geometry, schemaGeometry );
setDefaultModelSchema( model.Properties, schemaProperties );
*/

export var schema = {
    factory,
    schemaGeojson, 
    schemaFeature,
    schemaGeometry,
    schemaProperties
}